/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';

export const CEFR_LEVELS = ['A1', 'A2', 'B1', 'B2', 'C1', 'C2'] as const;

export const cefrLevelSchema = z.enum(CEFR_LEVELS);

export type ICEFRLevel = z.infer<typeof cefrLevelSchema>;
